import {Component} from '@angular/core';

/**
 * The "oder" divider between a primary form and the alternative doors below it (login's legacy toggle, the
 * invite landing's three provider buttons).
 *
 * Extracted (#576) because the two screens had grown two different copies of the same divider: the login
 * screen's used `py-1` on the row itself and let the surrounding form's `space-y-6` supply the gap above and
 * below, while the invite landing's carried its own `mt-5` on both sides — visibly taller, since it stacked on
 * top of what the row already contributes. One row, used by both, is what keeps them from drifting apart again.
 *
 * `text-gray-500`, not `-400`: at `text-xs` on white, gray-400 measures under the 4.5:1 axe floor (both
 * screens hit this independently before the fix).
 */
@Component({
  selector: 'auth-or-divider',
  standalone: true,
  // `display: block`, not the browser default `inline` for an unknown custom element: the surrounding forms
  // give it its vertical rhythm via a margin class on the host tag itself (`space-y-6` on login's form, an
  // explicit `mt-6` on the invite landing), and an inline box ignores a block-direction margin entirely.
  host: {class: 'block'},
  template: `
    <div class="relative flex items-center py-1">
      <div class="flex-grow border-t border-gray-200"></div>
      <span class="mx-3 text-xs text-gray-500">oder</span>
      <div class="flex-grow border-t border-gray-200"></div>
    </div>
  `
})
export class OrDividerComponent {
}
